<template>
<app-layout>
   <Head title="Lists"/>
        <template #header>
            <div class="md:flex justify-between items-center pb-1">
                <div class="mr-4 md:mr-5 flex justify-start items-center">
                    <PageBackHeader href="/groups" label="Lists" :subtitle="group.title" />
                </div>
                <div class="flex-shrink-0 mt-4 md:mt-0">
                    <button
                        @click="showContactImportModal = true"
                        class="text-gray-700 mr-4 py-2"
                    >Import Contacts to List</button>
                    <div class="sm:inline-block mt-2 sm:mt-0">
                        <jet-button
                            @click="showAddContactModal"
                        >Add Contact</jet-button>
                    </div>
                </div>
            </div>
        </template>

        <div class="max-w-7xl mx-auto flex mb-6">
          <div class="w-full p-2 sm:px-6 lg:px-8">
            <div class="grid grid-cols-12 gap-6">
              <div class="col-span-12 lg:col-span-4">
                <div class="bg-white shadow-xl p-4 sm:rounded-lg sm:p-6 lg:p-8">
                  <div class="flex justify-between mb-5">
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight mb-2">List Details</h2>
                    <Link :href="route('groups.edit.form', group.tra_id)" class="text-blue-600">
                      <font-awesome-icon :icon="['far', 'pen-to-square']" class="text-xl mr-2 text-gray-500"></font-awesome-icon>
                    </Link>
                  </div>
                  <div class="mb-5">
                    <div class="text-gray-600">List name</div>
                    <p> {{ group.title }} </p>
                  </div>
                  <div class="mb-5">
                    <div class="text-gray-600">Description</div>
                    <p> {{ group.description }}</p>
                  </div>
                  <div class="mb-5">
                    <div class="text-gray-600">Number of contacts</div>
                    <p> {{ group.contact_count }}</p>
                  </div>
                  <div class="mb-5">
                    <div class="text-gray-600">Last contacted</div>
                    <p> <date-tooltip :data="lastContacted" /> </p>
                  </div>
                  <div class="mb-5">
                    <div class="text-gray-600">Number of messages sent</div>
                    <p> {{ group.messages_sent_count }} </p>
                  </div>
                  <div class="mb-5">
                    <div class="text-gray-600">Associated forms</div>
                    <a
                        v-if="group.web_forms.data.length"
                        v-for="web_form in group.web_forms.data"
                        :key="web_form.id"
                        :href="route('web-forms.preview',[web_form.uuid])"
                        class="text-blue-600"
                      >
                        {{ web_form.name }} <br />
                      </a>
                      <p v-if="!group.web_forms.data.length">--</p>
                  </div>
                  <div class="mb-5">
                    <div class="text-gray-600">Associated keywords</div>

                    <a
                      v-if="group.keywords.data.length"
                      v-for="keyword in group.keywords.data"
                      :key="keyword.id"
                      class="text-blue-600 uppercase"
                      :href="'/keywords/view/' + keyword.id"
                    >
                      {{ keyword.keyword }} <br />
                    </a>
                    <p v-if="!group.keywords.data.length">--</p>
                  </div>
                  <div class="text-center">
                    <div class="sm:inline-block">
                      <button class="text-gray-700 focus:outline-none" @click="toggleDeletionModal(group.id)">
                        Delete List
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-12 lg:col-span-8">
              <div class="flex justify-between border-b-2 pb-3">
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight mb-2">History</h2>
                    <button
                      class="rounded-full leading-5 bg-blue-400 px-4 py-2 text-white"
                      @click="sendMessage(group.tra_id)"
                    >
                      <span class="mr-1 leading-5">+</span>
                      New Message to {{ group.title }}
                    </button>
                  </div>
                <div class="history overflow-auto" style="max-height:560px;">
                  <div class="bg-white shadow-sm p-2 sm:rounded-lg sm:p-6 lg:p-8 mt-5">
                    <div class="msg-box">
                      <div class="flex justify-between ">
                        <p class="font-bold text-gray-900 mb-2">List was created on</p>
                        <span class="text-gray-600" v-if="group.created_at"><date-tooltip :data="group.created_at" /></span>
                      </div>
                    </div>
                  </div>
                  <div v-if="prepareMessages.length" v-for="message in prepareMessages" :key="message.id" class="bg-white shadow-sm p-2 sm:rounded-lg sm:p-6 lg:p-8 mt-5">
                    <div class="msg-box">
                      <div class="flex justify-between ">
                        <p class="font-bold text-gray-900 mb-2">Message Sent</p>
                        <span class="text-gray-600" v-if="message.true_send_time"><date-tooltip :data="message.true_send_time" /></span>
                      </div>
                      {{ group.title }} was sent a message (<Link :href="route('message.details', message.tra_id)" class="text-blue-600">view details</Link>)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8">
                    <h2
                        class="font-semibold text-xl text-gray-800 leading-tight mb-2"
                    >
                        Contacts
                    </h2>

                    <general-table
                        :columns="columns"
                        :url="route('contacts.table') + '?group_tra_id=' + group.tra_id "
                        :clickableRow="{route: 'contacts.view',id: 'id'}"
                    />

                </div>
            </div>
        </div>

        <contact-import-modal
            v-if="showContactImportModal"
            :is-open="showContactImportModal"
            :group-tra-id="group.tra_id"
            @close="closeContactImportModal()"
        ></contact-import-modal>
        <group-add-contact-modal
            v-if="showAddModal"
            :group-tra-id="group.tra_id"
            :group-title="group.title"
            @close="handleAddModalClose"
        />

        <jet-dialog-modal
            v-if="showDeletionModal"
            :show="showDeletionModal"
            @close="showDeletionModal = false"
        >
            <template #title>
                Remove Contact
            </template>

            <template #content>
                Are you sure you want to remove this contact from the list?
            </template>

            <template #footer>
                <button @click="modalClose">
                    Cancel
                </button>
                <jet-danger-button
                    class="ml-2"
                    @click.native="removeContactFromGroup(idSetForRemoval)"
                >
                    Remove Contact
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
        <jet-dialog-modal v-if="showListDeletionModal" :show="showListDeletionModal" @close="showListDeletionModal = false">
          <template #title>
            Delete List
          </template>

          <template #content>
            Are you sure you want to delete this List?
          </template>

          <template #footer>
            <jet-secondary-button @click="toggleDeletionModal()">
              Cancel
            </jet-secondary-button>
              <jet-danger-button class="ml-2" @click.native="deleteList(group.tra_id)">
                Delete List
              </jet-danger-button>
          </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script>
import ContactImportModal from "../../components/ContactImportModal";
import JetDropdown from '../../Jetstream/Dropdown';
import JetDropdownLink from '../../Jetstream/DropdownLink';
import JetNavLink from '../../Jetstream/NavLink';
import DateTooltip from '../../components/DateTooltip.vue'
import ContactTableName from "@/components/ContactTableName";
import GroupAddContactModal from "../../components/GroupAddContactModal";
import MessageDeliverableDeleteButton from "../../components/MessageDeliverableDeleteButton";
import ContactTableFirstName from "../../components/ContactTableFirstName";
import axios from "axios";
import Button from "../../Jetstream/Button.vue";
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '@/Stores/general_table';
import {markRaw} from 'vue';
export default {
    components: {
      Button,
        ContactImportModal,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        GroupAddContactModal,
        MessageDeliverableDeleteButton,
        ContactTableFirstName,
        DateTooltip
    },
    props: {
        data: Array,
        links: Object,
        meta: Object,
        group: Object
    },
    data() {
        return {
            showAddModal: false,
            showContactImportModal: false,
            showDeletionModal: false,
            showListDeletionModal: false,
            idSetForRemoval: false,
            listSetForDeletion: null,
            columns: [
                {
                    label: "Name",
                    name: "name",
                    sortable: true,
                    component: markRaw(ContactTableName),
                    width: '1fr',
                },
                {
                    label: "Phone Number",
                    name: "phone_number",
                    sortable: true,
                    width: '1fr',
                },
                {
                    label: "",
                    name: "Delete",
                    sortable: false,
                    component: markRaw(MessageDeliverableDeleteButton),
                    eventHandler: this.handleDeletionClick,
                    width: '60px',
                }
            ]
        };
    },
    computed: {
      prepareMessages() {
          let messages = this.group.latestMessages.data;
          return messages.toReversed();
        },
      lastContacted() {
        if(this.group.last_message_activity){
          return this.group.last_message_activity
        } else {
          return null
        }
      }
    },
    methods: {
        ...mapActions(useGeneralTableStore, ['clearData', 'fetchData']),
        showAddContactModal() {
            console.log("showAddContactModal");
            this.showAddModal = true;
        },
        removeContactFromGroup() {
            this.$inertia.post(
                route(
                    "groups.removeContact.submit.json",
                    this.group.tra_id
                ),
                {
                    contact_id: this.idSetForRemoval
                },
                {
                    onSuccess: page => {
                        this.showDeletionModal = false;
                        this.fetchData();

                    },
                    onError: errors => {
                        this.$toasted.show(errors.contact_id, {
                            position: "bottom-right",
                            duration: 2000,
                            type: "error"
                        });
                    }
                }
            );
            document.body.style.overflow = null

        },
        handleDeletionClick(data, type) {
            this.idSetForRemoval = data.id;
            this.showDeletionModal = true;
            document.body.style.overflow = null

        },
        handleAddModalClose() {
            this.showAddModal = false;
        },
        closeContactImportModal() {
            this.showContactImportModal = false;
        },
        formatDate(date) {
            return this.group.last_message_activity =  new Date(date)
              .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
          },
        toggleDeletionModal() {
          this.showListDeletionModal = !this.showListDeletionModal;
          document.body.style.overflow = null;
        },
        modalClose(){
          this.showDeletionModal = false;
          document.body.style.overflow = null
        },
        deleteList(traId) {
          let vm = this;
          axios
            .post(`/groups/delete/${traId}`, {
              redirectToGroups: true
            })
            .then(function(res) {
              vm.$inertia.visit("/groups")

              vm.$toasted.show(res.data, {
                position: "bottom-right",
                type: "success",
                duration: 3000
              });
            })
            .catch(function(err) {
              vm.$inertia.visit("/groups");
              vm.$toasted.show(err.response.data.message, {
                position: "bottom-right",
                type: "error",
                duration: 3000
              });
            });
            document.body.style.overflow = null
        },
        sendMessage(groupId) {
          let vm = this;
          vm.$inertia.visit(route("dashboard", { list_id: groupId }));
        },
    }
};
</script>
